import { R as ResizeObserver } from './ResizeObserver-f193871f.js';
import { n as getHeaderHeight, k as getSDLHeaderSelector } from './lookups-705fb53e.js';
import './request.constants-deb285e0.js';
import './utils-15ad90ec.js';
import './isObject-33fa1780.js';

function observeIntersectionWithHeader(ref, callback) {
  if (!ref) {
    return;
  }
  let headerHeight = getHeaderHeight();
  let viewportHeight = window.innerHeight;
  if (!headerHeight) {
    return;
  }
  const setupIntersectionObserver = () => {
    const tabBarHeight = 48;
    const offset = 5;
    const topMargin = (headerHeight !== null && headerHeight !== void 0 ? headerHeight : 0) + tabBarHeight + offset;
    const bottomMargin = viewportHeight - topMargin - offset * 3;
    const observer = new IntersectionObserver(callback, {
      rootMargin: `-${topMargin}px 0px -${bottomMargin}px 0px`,
    });
    observer.observe(ref);
    return observer;
  };
  let observer = setupIntersectionObserver();
  const ResizeObserver$1 = window.ResizeObserver || ResizeObserver;
  let headerRO;
  {
    headerRO = new ResizeObserver$1(([entry]) => {
      const { height } = entry.contentRect;
      if (height !== headerHeight) {
        headerHeight = height;
        observer.disconnect();
        observer = setupIntersectionObserver();
      }
    });
    window.addEventListener('resize', () => {
      if (window.innerHeight !== viewportHeight) {
        viewportHeight = window.innerHeight;
        observer.disconnect();
        observer = setupIntersectionObserver();
      }
    });
  }
  const sdlHeader = document.querySelector(getSDLHeaderSelector());
  if (sdlHeader && headerRO) {
    headerRO.observe(sdlHeader);
  }
}
function initSDLHeaderResizeObserver(callback) {
  const headerEl = document.querySelector(getSDLHeaderSelector());
  if (headerEl) {
    const ResizeObserver$1 = window.ResizeObserver || ResizeObserver;
    const sdlHeaderResizeObserver = new ResizeObserver$1(callback);
    sdlHeaderResizeObserver.observe(headerEl);
    return sdlHeaderResizeObserver;
  }
}
function setStickyBarTab(tabName, titles) {
  var _a;
  if (!tabName)
    return;
  (_a = window.__STICKYBARSTORE) === null || _a === void 0 ? void 0 : _a.setItem({
    name: tabName,
    titles,
  });
}
function setTabActive(tab) {
  window.__STICKYBARSTORE.active = tab;
}

export { setTabActive as a, initSDLHeaderResizeObserver as i, observeIntersectionWithHeader as o, setStickyBarTab as s };
